import React from 'react';
import PropTypes from 'prop-types';
import Tag from 'components/Tag';
import { useTranslation } from 'react-i18next';
import { CURRENCIES, CURRENCIES_SYMBOLS } from 'utils/constants/formats';
import numeral from 'numeral';

const Price = ({
  className,
  price,
  row,
  currency,
  showVat,
  showForSide,
  vat,
  isNegotiablePrice,
  showPrice,
}) => {
  const { t } = useTranslation('Offers');

  const getSymbol = () => {
    switch (currency) {
      case CURRENCIES.EUR:
        return CURRENCIES_SYMBOLS.EUR;
      case CURRENCIES.GBP:
        return CURRENCIES_SYMBOLS.GBP;
      default:
        return CURRENCIES_SYMBOLS.EUR;
    }
  };

  const renderPrice = () => {
    if (isNaN(parseFloat(price))) {
      return (
        <span className="price__number">
          <strong>{`-`}</strong>
        </span>
      );
    }
    return (
      <>
        {showVat && showPrice && !showForSide && !isNegotiablePrice && (
          <span className="price__vat">{t('vatNotInc')}</span>
        )}
        {isNegotiablePrice && (
          <Tag
            className="price__negotiable_tag"
            skin="blue"
            text={t('negotiable')}
            data-testid="price-negotiable-tag"
          />
        )}
        {showPrice && (
          <span
            className={`price__number ${
              showForSide ? 'price__number--side' : ''
            } ${isNegotiablePrice ? 'price__number--negotiable_amount' : ''}`}
            data-testid="price-value"
          >
            <strong>{`${numeral(parseFloat(price)).format(
              t('currencyFormat')
            )} ${getSymbol()}`}</strong>
          </span>
        )}
      </>
    );
  };

  return (
    <div className={className}>
      <div
        className={`price ${row ? 'price--row' : ''} ${
          showForSide ? 'price--side' : ''
        } ${isNegotiablePrice ? 'price--negotiable' : ''}`}
      >
        {renderPrice()}
        {showForSide && showPrice && (
          <div
            className="price__with-vat-container"
            data-testid="price-vat-container"
          >
            <span className={`price__vat-number`}>{`${numeral(
              parseFloat(vat)
            ).format(t('currencyFormat'))} ${getSymbol()}`}</span>
            <span className="price__vat-inc">{t('vatInc')}</span>
          </div>
        )}
      </div>
    </div>
  );
};

Price.defaultProps = {
  row: false,
  small: false,
  showVat: true,
  currency: CURRENCIES.EUR,
  showForSide: false,
  isNegotiablePrice: false,
  vat: 0,
  showPrice: true,
};

Price.propTypes = {
  className: PropTypes.string,
  price: PropTypes.string.isRequired,
  currency: PropTypes.oneOf([CURRENCIES.EUR, CURRENCIES.GBP, '']),
  row: PropTypes.bool,
  small: PropTypes.bool,
  showVat: PropTypes.bool,
  showForSide: PropTypes.bool,
  isNegotiablePrice: PropTypes.bool,
  vat: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showPrice: PropTypes.bool,
};

export default Price;
